import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "#262626",
	viewBox: "0 0 21 22",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.375 14.75h-.625c-.69 0-1.25-.56-1.25-1.25v-3.125a.625.625 0 0 0-.625-.625H9.25m.938-3.125a.312.312 0 1 0 0 .625.312.312 0 0 0 0-.625v0",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 20.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75Z",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20stroke%3D%22%23262626%22%20viewBox%3D%220%200%2021%2022%22%3E%3Cpath%20d%3D%22M12.375%2014.75h-.625c-.69%200-1.25-.56-1.25-1.25v-3.125a.625.625%200%200%200-.625-.625H9.25m.938-3.125a.312.312%200%201%200%200%20.625.312.312%200%200%200%200-.625v0%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M10.5%2020.375a9.375%209.375%200%201%200%200-18.75%209.375%209.375%200%201%200%200%2018.75Z%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
